import { UnreachableFunction } from 'ui/base/types';
import { Theme, ThemedStyles } from 'ui/base/theme';

import { IssueKind } from 'services/pangolin/types';

import baseStyles from './issue_kinds.module.css';

import issueKindIconImageUnknownDaylight from './issue_kinds_icons/unknown/light.png';
import issueKindIconImageUnknownMidnight from './issue_kinds_icons/unknown/dark.png';
import issueKindIconImageMaliciousDaylight from './issue_kinds_icons/malicious/light.png';
import issueKindIconImageMaliciousMidnight from './issue_kinds_icons/malicious/dark.png';
import issueKindIconImageMalwareDaylight from './issue_kinds_icons/malware/light.png';
import issueKindIconImageMalwareMidnight from './issue_kinds_icons/malware/dark.png';

export type IssueKindIconStyles = {
  unknown: string;
  malicious: string;
  malware: string;
};

export const themedIssueKindIconClassStyles: ThemedStyles<IssueKindIconStyles> = {
  [Theme.DAYLIGHT]: {
    unknown: baseStyles.issueKindIconClassUnknownDaylight,
    malicious: baseStyles.issueKindIconClassMaliciousDaylight,
    malware: baseStyles.issueKindIconClassMalwareDaylight,
  },
  [Theme.MIDNIGHT]: {
    unknown: baseStyles.issueKindIconClassUnknownMidnight,
    malicious: baseStyles.issueKindIconClassMaliciousMidnight,
    malware: baseStyles.issueKindIconClassMalwareMidnight,
  },
};

export const themedIssueKindIconImageStyles: ThemedStyles<IssueKindIconStyles> = {
  [Theme.DAYLIGHT]: {
    unknown: issueKindIconImageUnknownDaylight,
    malicious: issueKindIconImageMaliciousDaylight,
    malware: issueKindIconImageMalwareDaylight,
  },
  [Theme.MIDNIGHT]: {
    unknown: issueKindIconImageUnknownMidnight,
    malicious: issueKindIconImageMaliciousMidnight,
    malware: issueKindIconImageMalwareMidnight,
  },
};

export const getIssueKindIcon = (styles: IssueKindIconStyles, kind: IssueKind): string => {
  switch(kind) {
    case IssueKind.UNKNOWN:
      return styles.unknown;
    case IssueKind.MALICIOUS_DOMAIN:
      return styles.malicious;
    case IssueKind.MALICIOUS_ADDRESS:
      return styles.malicious;
    case IssueKind.MALWARE_DOMAIN:
      return styles.malware;
    case IssueKind.MALWARE_ADDRESS:
      return styles.malware;
    default:
      return UnreachableFunction(kind);
  }
};
